import { createContext } from 'react';
import { ContextType, ResumeDocument, TemplateId } from '../types';

const initialContext: ContextType = {
  data: [],
  keys: [],
  applied: [],
  applications: {},
  alerts: [],
  error: false,
  refreshing: false,
  onboardingCompleted: false,
  hydrated: false,
  themeMode: 'light',
  language: '',
  hideAds: false,
  removeAdsEntitled: false,
  disclaimerAcknowledged: false,
  removeAdsPurchasing: false,
  removeAdsPriceString: null,
  removeAdsLastError: null,
  resumes: [],
  refresh: () => null,
  handleClearFavorites: () => null,
  handleFavorites: () => null,
  handleApplied: () => null,
  setApplicationStatus: () => null,
  setApplicationNotes: () => null,
  setApplicationStageDate: () => null,
  removeApplicationStage: () => null,
  removeApplication: () => null,
  addManualApplication: () => null,
  addAlert: () => ({ id: '', query: '', tags: [], enabled: true, createdAt: '', updatedAt: '' }),
  updateAlert: () => null,
  deleteAlert: () => null,
  toggleAlert: () => null,
  completeOnboarding: () => null,
  acknowledgeDisclaimer: () => null,
  setThemeMode: () => null,
  setLanguage: () => null,
  setHideAds: () => null,
  purchaseRemoveAds: async () => ({ outcome: 'failed' as const }),
  restoreRemoveAds: async () => ({ outcome: 'failed' as const }),
  resetRemoveAdsForTesting: async () => false,
  addResume: (_name: string, _template?: TemplateId): ResumeDocument => ({
    id: '',
    name: '',
    template: 'modern',
    createdAt: '',
    updatedAt: '',
    personalInfo: {
      fullName: '',
      title: '',
      email: '',
      phoneCountryCode: '',
      phone: '',
      location: '',
      website: '',
      summary: '',
      photo: '',
    },
    experience: [],
    education: [],
    skills: [],
    languages: [],
    links: [],
    personalization: {
      colorMode: 'light',
      fontFamily: 'sans',
      fontScale: { title: 1, subtitle: 1, body: 1 },
    },
  }),
  updateResume: () => null,
  deleteResume: () => null,
  duplicateResume: () => null,
  deleteAccount: async () => ({ ok: false }),
};

const JobsContext = createContext(initialContext);

export default JobsContext;
